import { VisualisationContextProps } from 'widgets/supportVisualisation/Content/VisualisationContentProps';
import React from 'react';

import './SupportVisualisationConnectivity.scss';
import LabelValue from 'utils/components/LabelValue/LabelValue';
import { toDateString } from 'widgets/supportVisualisation/SupportVisualisationHelpers';
import { Grid } from '@instinet-analytics/semantic-ui-components';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { ConnectivityStatus } from 'app/store/connectivity/ConnectivityState';
import { GetRowClassParams } from '@instinet-analytics/semantic-ui-components';

export default function SupportVisualisationConnectivity(
    props: VisualisationContextProps
) {
    const { state } = props;

    const connectivity = state?.state.app.connectivity;

    if (!connectivity) {
        return <div>None found in state</div>;
    }

    const columnDefs = getColumns();
    const rowData = getRowData(connectivity.history);

    return (
        <div className={'SupportVisualisationConnectivity'}>
            <div className="current">
                <div className="title">Current</div>
                <LabelValue
                    label="Connected?"
                    value={connectivity.current.connected ? 'Yes' : 'No'}
                />
                <LabelValue
                    label="Timestamp"
                    value={toDateString(connectivity.current.timestamp)}
                />
                {connectivity.current.disconnectedReason && (
                    <LabelValue
                        label="Disconnected Reason?"
                        value={connectivity.current.disconnectedReason}
                    />
                )}
                {connectivity.current.lostConnectionStatus && (
                    <>
                        <LabelValue
                            label="Error Code"
                            value={(
                                connectivity.current.lostConnectionStatus
                                    .errorCode ?? ''
                            ).toString()}
                        />
                        <LabelValue
                            label="Did Connect?"
                            value={
                                connectivity.current.lostConnectionStatus
                                    .didConnect
                                    ? 'Yes'
                                    : 'No'
                            }
                        />
                    </>
                )}

                <div className="title">History</div>
            </div>
            <Grid
                autoSizeColumns={true}
                singleSelectOnly={true}
                columnDefs={columnDefs}
                rowData={rowData}
                rowClassRules={getRowClassRules()}
                getRowDataId={(r) => r.id.toString()}
            />
        </div>
    );
}

interface RowData {
    id: number;
    timestamp: string;
    connected: string;
    disconnectedReason: string;
    errorCode: string;
}

function getRowData(history: ConnectivityStatus[]): RowData[] {
    let id = 0;
    return history.map((h) => ({
        id: id++,
        timestamp: toDateString(h.timestamp),
        connected: h.connected ? 'Yes' : 'No',
        disconnectedReason: h.disconnectedReason ?? '',
        errorCode: (h.lostConnectionStatus?.errorCode ?? '').toString(),
    }));
}

function getColumns(): ColDef[] {
    return [
        {
            field: 'timestamp',
            headerName: 'Time',
            resizable: true,
            width: 80,
        },
        {
            field: 'connected',
            headerName: 'Connected',
            width: 70,
        },
        {
            field: 'disconnectedReason',
            headerName: 'Disconnected Reason',
            sortable: true,
            resizable: true,
        },
        {
            field: 'errorCode',
            headerName: 'Error Code',
            resizable: true,
        },
    ];
}

function getRowClassRules() {
    return {
        connected: (params: GetRowClassParams<RowData>) => {
            const item: RowData = params.data;
            return item.connected === 'Yes';
        },
    };
}
